<template>
  <div>

    <MaterialSelect>

    </MaterialSelect>
    <OfferCalculation>

    </OfferCalculation>
    <div>
      <h4>{{ $t("steps.offer.surfaces.title") }}</h4>
      <v-data-table :items="surfacesWithIndex" :headers="surfacesHeader">
        <template slot="body.append">
          <tr>
            <th>{{ $t("steps.offer.surfaces.footers.summary") }}</th>
            <th>{{ surfaceSumary }}</th>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div style="padding: 20px 0 10px">
      <v-btn @click="$emit('complete')" color="primary">{{
        $t("base.next")
      }}</v-btn>
      <v-btn @click="$emit('abort')" text>{{
        $t("steps.back_to_surface")
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/orders/MaterialSelect";
import OfferCalculation from "@/components/orders/OfferCalculation";

export default {
  name: "Offer",
  components: {MaterialSelect, OfferCalculation },
  computed: {
    surfaces() {
      return this.$store.state.configurator.surfaces;
    },
    surfacesWithIndex() {
      return this.surfaces.map((surfaces, index) => ({
        ...surfaces,
        index: index + 1,
      }));
    },
    surfacesHeader() {
      return [
        {
          text: this.$t("steps.offer.surfaces.headers.number"),
          value: "index",
        },
        {
          text: this.$t("steps.offer.surfaces.headers.surface"),
          value: "area",
        },
      ];
    },
    surfaceSumary() {
      return this.$store.getters.summarySurfaceArea;
    },
  },
  data() {
    return {
    };
  },
  methods: {

  },
  mounted() {
    // this.loading = true;
    // this.$store
    //   .dispatch("prepareMaterials")
    //   .then(() => {
    //     this.loading = false;
    //     this.loaded = true;
    //   })
    //   .catch(() => {
    //     this.loading = false;
    //   });
  },
  watch: {

  },
};
</script>

<style scoped>
.product-summary-row {
  color: #464646;
  padding: 10px 16px;
  line-height: 20px;
  font-size: 18px;
  font-weight: lighter;
  display: block;
  width: 100%;
}

.product-summary-row .value {
  font-weight: initial;
}
.title {
  text-align: left;
}
.complementary {
  height: 30px;
  line-height: 30px;
}
</style>
